(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("rxjs"));
	else if(typeof define === 'function' && define.amd)
		define(["rxjs"], factory);
	else if(typeof exports === 'object')
		exports["ocJsCommon"] = factory(require("rxjs"));
	else
		root["ocJsCommon"] = factory(root["rxjs"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 